export default __webpack_public_path__ + "static/media/my_current-location.e9f128ae.svg";